import { FunctionComponent, ReactNode } from "react";
import { cn } from "../../utils/cn";

export interface ModalHeaderProps {
  className?: string;
  children: ReactNode;
  "data-testid"?: string;
}

/**
 *
 */
export const ModalHeader: FunctionComponent<ModalHeaderProps> = ({
  className,
  children,
  "data-testid": dataTestId,
}) => {
  const css = cn(className, "p-4 pb-3 border-b font-semibold text-xl");
  const testId = dataTestId || "modal-header";
  return (
    <div className={css} data-testid={testId}>
      {children}
    </div>
  );
};

export default ModalHeader;
